// src/redux/posts/publicUserPosts/publicUserPostsAPI.js
import apiClient from "../../authentication/utils/core/axios";

const PublicUserPostsAPI = {
  async fetch(userId, skip = 0, limit = 20, sort_by = "latest", period = "all") {
    const { data } = await apiClient.get(`/users-history/${userId}/posts`, {
      params: { skip, limit, sort_by, period }
    });
    return data;
  }
};

export default PublicUserPostsAPI;
